import React from 'react'

import { CartV2LineItem } from '@Domains/Cart/Feature/CartV2/CartV2'
import { MatchingVariantTactic } from '@Domains/Product/Features/Tactics/Components/MatchingVariant/AddToCartPromptSuccess'
import { QuantityDiscount } from '@Domains/Product/Features/Tactics/Components/QuantityDiscount/QuantityDiscount'
import { AddToCartPromptSuccessRecommendations } from '@Domains/Product/Features/Tactics/Components/Recommendation/AddToCartPromptSuccess'
import { AddAndSaveTactic } from '@Domains/Product/Features/Tactics/Components/TacticAddAndSave/AddAndSaveTactic'
import { UpgradeWith } from '@Domains/Product/Features/Tactics/Components/UpgradeWith/AddToCartPromptSuccess'
import { AddToCartPromptSuccessTacticFragmentFragment } from '@Generated/graphql'

const AddToCartPromptSuccessTactics = ({
  lineItem,
  tactics,
}: {
  lineItem?: CartV2LineItem
  tactics: AddToCartPromptSuccessTacticFragmentFragment[] | null | undefined
}) => {
  if (!tactics || tactics.length === 0) {
    return null
  }

  return tactics.map((tactic) => {
    // if (tactic.__typename === 'TacticBuildYourDiscount') {
    //   return (
    //     <BuildYourDiscountTactic
    //       key={`${tactic.__typename}_${tactic.id}`}
    //       disable={addonsSelected}
    //       primaryProduct={product}
    //       tactic={tactic}
    //     />
    //   )
    // }

    if (tactic.__typename === 'TacticAddAndSave' && lineItem) {
      return (
        <AddAndSaveTactic
          key={`TacticAddAndSave_${tactic.id}`}
          lineItem={lineItem}
          showProgressBar
          tactic={tactic}
        />
      )
    }

    if (tactic.__typename === 'TacticBoughtTogether') {
      return (
        <AddToCartPromptSuccessRecommendations
          key={`TacticAddAndSave_${tactic.id}`}
          tactic={tactic}
        />
      )
    }

    if (tactic.__typename === 'TacticMatchingVariant' && lineItem?.id) {
      return (
        <MatchingVariantTactic
          key={`${tactic.__typename}_${tactic.id}`}
          parentLineItemID={lineItem.id}
          tactic={tactic}
        />
      )
    }

    if (tactic.__typename === 'TacticRelativeDiscount' && lineItem) {
      return (
        <QuantityDiscount
          key={`${tactic.__typename}_${tactic.id}`}
          lineItem={lineItem}
          showProgressBar
          tactic={tactic}
        />
      )
    }

    if (tactic.__typename === 'TacticUpgradeWith') {
      return (
        <UpgradeWith
          key={`${tactic.__typename}_${tactic.id}`}
          parentLineItemID={lineItem?.id}
          tactic={tactic}
        />
      )
    }

    return null
  })
}

export default AddToCartPromptSuccessTactics
